import {Outlet} from "react-router-dom";

const Trainings = () => {

    return (
        <Outlet />
    )
}

export default Trainings